(function () {
  // -------- helpers --------
  function money(cents) {
    try {
      return Shopify.formatMoney(
        cents,
        window.themeMoneyFormat || "{{ shop.money_format | replace: '\"', '\\\"' }}"
      );
    } catch (e) {
      return (Math.round(cents) / 100).toFixed(2);
    }
  }

  // Compute and apply label for ONE span based on current select state
  function applyLabelForSpan(select, span) {
    if (!select || !span) return;

    const addLabel = span.dataset.labelAdd || "Add to cart";
    const selectLabel = span.dataset.labelSelect || addLabel;
    const tpl = span.dataset.labelSaveTemplate; // contains [[savings]]

    const opt = select.selectedOptions && select.selectedOptions[0];
    let newText = selectLabel;

    if (opt && opt.value) {
      const price = +opt.dataset.price || 0;
      const compare = +opt.dataset.compare || 0;
      if (compare > price && tpl) {
        newText = tpl.replace("[[savings]]", money(compare - price));
      } else {
        newText = addLabel;
      }
    }

    if (span.textContent !== newText) {
      span.textContent = newText;
    }
  }

  // Update ALL buttons on the page that use data-btn-text (main + sticky)
  function updateAllButtons() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const select = form.querySelector('select[name="id"]');
    if (!select) return;

    // Target every ATC label on the page (main, sticky, etc.)
    document.querySelectorAll('[data-btn-text]').forEach((span) => {
      applyLabelForSpan(select, span);
    });
  }

  // Wire listeners once
  function initListeners() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const select = form.querySelector('select[name="id"]');
    if (select) {
      select.addEventListener("change", updateAllButtons);
    }

    // Size/option pills (theme renders them outside the select)
    document.addEventListener(
      "click",
      (e) => {
        if (e.target.closest("[data-option-item]")) {
          // let the theme set the variant first
          setTimeout(updateAllButtons, 0);
        }
      },
      true
    );

    // Theme events (some themes dispatch one or both)
    document.addEventListener("variant:change", () => {
      setTimeout(updateAllButtons, 0);
    });
    document.addEventListener("variant:changed", () => {
      setTimeout(updateAllButtons, 0);
    });

    // In case the sticky bar mounts late, update on DOM ready too
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", updateAllButtons);
    } else {
      updateAllButtons();
    }
  }

  // Boot
  initListeners();
  console.log("✅ ATC label script loaded (multi-button, no observers)");
})();
